/** scope → 감자 캐릭터 이미지 매핑 */
const SCOPE_IMAGES: Record<string, string> = {
  // C언어
  "포인터": "/folder-icons/pointer.webp",
  "제어문/반복문": "/folder-icons/loop.webp",
  "구조체": "/folder-icons/struct.webp",
  "메모리": "/folder-icons/memory.webp",
  "배열": "/folder-icons/array.webp",
  "문자열": "/folder-icons/string.webp",
  "연산자": "/folder-icons/operator.webp",
  "기초": "/folder-icons/basic.webp",
  "자료구조": "/folder-icons/data-structure.webp",
  "함수": "/folder-icons/function.webp",
  "수/진법": "/folder-icons/number.webp",
  // Java
  "객체지향": "/folder-icons/oop.webp",
  "클래스/메서드": "/folder-icons/class.webp",
  "배열/문자열": "/folder-icons/array-string.webp",
  "알고리즘": "/folder-icons/algorithm.webp",
  // Python
  "리스트": "/folder-icons/list.webp",
  "딕셔너리/집합": "/folder-icons/dict.webp",
  "클래스": "/folder-icons/class.webp",
  "함수/클래스": "/folder-icons/function.webp",
  // 공통
  "프로그래밍 기초": "/folder-icons/programming.webp",
  // DB
  "SQL": "/folder-icons/sql.webp",
  "논리DB 설계": "/folder-icons/logical-db.webp",
  "물리DB 설계": "/folder-icons/physical-db.webp",
  // SW설계
  "디자인패턴": "/folder-icons/design-pattern.webp",
  "응집도/결합도": "/folder-icons/cohesion.webp",
  "UML": "/folder-icons/uml.webp",
  // SW개발
  "테스트": "/folder-icons/test.webp",
  "인터페이스": "/folder-icons/interface.webp",
  // 네트워크/OS
  "네트워크 7계층": "/folder-icons/network-layer.webp",
  "메모리/프로세스": "/folder-icons/process.webp",
  "shell script": "/folder-icons/shell.webp",
  "IP": "/folder-icons/ip.webp",
  // 보안/신기술
  "암호 알고리즘": "/folder-icons/crypto.webp",
  "공격 유형": "/folder-icons/attack.webp",
  "보안기능": "/folder-icons/security.webp",
  "신기술 및 장비": "/folder-icons/newtech.webp",
};

export const DEFAULT_IMAGE = "/default_gamja.webp";

const POST_IMAGE_OVERRIDES: Record<string, string> = {
  "/coding/c-language/sizeof": "/folder-icons/coding/common/sizeof.webp",
  "/coding/c-language/linked-list-reverse": "/folder-icons/coding/c-language/linked-list.webp",
};

export function getScopeImage(scope: string): string {
  return SCOPE_IMAGES[scope] || DEFAULT_IMAGE;
}

/** 개별 글 이미지 경로 (href 기반 convention) */
export function getPostImage(href: string): string {
  const override = POST_IMAGE_OVERRIDES[href];
  if (override) return override;

  // /coding/c-language/pointer → /folder-icons/coding/c-language/pointer.webp
  return `/folder-icons${href}.webp`;
}
